var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 768,
    viewBox: "0 0 1280 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_569)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_101_569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1095.8 402.298C1111.23 408.669 1125.81 416.313 1139.95 425.231C1234.68 483.837 1294.69 598.075 1277.12 707.218C1259.12 818.059 1140.81 975.614 1023.79 998.547C985.635 1006.19 946.628 995.574 909.335 984.108C846.752 964.997 788.026 933.996 726.3 916.159C702.296 909.364 676.148 907.666 653 917.009C612.707 933.146 602.848 967.97 585.702 1003.22C566.412 1043.14 533.835 1076.69 494.399 1097.5C413.383 1139.96 308.792 1120 233.777 1074.14C122.327 1006.19 82.4628 872.417 119.327 750.959C128.757 719.533 143.76 688.532 168.622 666.448C211.059 628.227 274.928 621.432 330.653 635.447C369.232 645.214 404.381 663.9 437.816 684.285C465.25 701.272 490.541 724.629 524.404 724.629C592.989 725.054 613.993 637.57 635.854 588.732C664.574 524.181 713.012 467.699 773.023 429.903C869.899 368.324 990.351 357.707 1095.8 402.298Z",
    fill: "url(#paint0_linear_101_569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.84 402.557C1111.26 408.925 1125.83 416.568 1139.97 425.485C1234.65 484.078 1294.64 598.293 1277.07 707.414C1259.08 818.232 1140.82 975.756 1023.86 998.684C985.723 1006.33 946.734 995.712 909.458 984.248C846.904 965.141 788.206 934.146 726.509 916.313C702.515 909.519 676.38 907.821 653.243 917.162C612.969 933.297 603.114 968.113 585.976 1003.35C566.696 1043.27 534.133 1076.81 494.716 1097.61C413.738 1140.07 309.195 1120.12 234.216 1074.26C122.818 1006.33 82.972 872.58 119.819 751.147C129.245 719.727 144.241 688.732 169.091 666.653C211.508 628.439 275.347 621.646 331.046 635.658C369.607 645.423 404.74 664.105 438.16 684.486C465.581 701.469 490.859 724.822 524.707 724.822C593.26 725.246 614.254 637.781 636.105 588.952C664.812 524.414 713.227 467.944 773.21 430.155C870.041 368.589 990.436 357.974 1095.84 402.557Z",
    fill: "url(#paint1_radial_101_569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3201 1274.59C-107.431 1129.77 5.73332 810.839 192.198 713.163C262.068 676.641 343.512 662.626 421.956 672.819C492.684 682.161 580.986 705.943 653.429 678.764C708.296 657.955 733.587 606.569 762.307 559.854C842.036 429.903 1043.07 405.696 1142.95 528.853C1179.82 574.293 1194.82 637.57 1176.81 693.203C1134.38 822.305 992.065 767.097 911.478 836.32C879.329 863.924 870.756 919.132 851.895 956.079C832.606 993.875 809.03 1029.97 783.739 1064.37C730.586 1136.99 665.86 1203.24 591.274 1254.63C442.531 1357.4 256.496 1387.98 99.1798 1283.93C94.8932 1280.96 90.6066 1277.99 86.3201 1274.59Z",
    fill: "url(#paint2_linear_101_569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3201 1274.59C-107.431 1129.77 5.73332 810.839 192.198 713.163C262.068 676.641 343.512 662.626 421.956 672.819C492.684 682.161 580.986 705.943 653.429 678.764C708.296 657.955 733.587 606.569 762.307 559.854C842.036 429.903 1043.07 405.696 1142.95 528.853C1179.82 574.293 1194.82 637.57 1176.81 693.203C1134.38 822.305 992.065 767.097 911.478 836.32C879.329 863.924 870.756 919.132 851.895 956.079C832.606 993.875 809.03 1029.97 783.739 1064.37C730.586 1136.99 665.86 1203.24 591.274 1254.63C442.531 1357.4 256.496 1387.98 99.1798 1283.93C94.8932 1280.96 90.6066 1277.99 86.3201 1274.59Z",
    fill: "url(#paint3_radial_101_569)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M776.107 170.573C784.791 168.293 794.524 173.083 799.436 180.281C804.13 187.042 805.407 196.572 802.037 204.145C800.807 206.822 798.843 209.19 796.948 211.474C796.655 211.828 796.363 212.179 796.076 212.53C793.548 215.788 791.161 219.394 789.688 223.155C788.11 227.135 787.561 231.457 787.023 235.694C786.953 236.243 786.884 236.79 786.812 237.335C786.539 239.135 786.265 240.935 786.016 242.737C786.035 244.887 785.795 247.037 785.237 249.107C784.869 251.692 784.192 254.235 782.553 256.292C781.047 258.274 778.84 258.989 776.534 258.956C775.849 259.037 775.134 259.009 774.392 258.848C773.469 258.671 772.6 258.367 771.774 257.971C771.537 257.88 771.303 257.784 771.074 257.684C767.345 256.014 764.272 253.198 761.913 249.894C760.889 248.997 759.858 248.108 758.827 247.218C758.418 246.851 758.009 246.481 757.6 246.109C754.435 243.241 751.207 240.314 747.42 238.318C743.855 236.419 739.697 235.232 735.657 234.402C735.211 234.322 734.761 234.245 734.309 234.167C731.383 233.664 728.351 233.143 725.676 231.91C718.19 228.349 712.962 220.28 712.131 212.091C711.18 203.428 715.458 193.46 723.537 189.543C731.855 185.508 742.073 188.001 749.915 191.679C751.738 192.507 753.551 193.429 755.333 194.438C755.98 192.698 756.691 190.998 757.46 189.351C761.024 181.456 767.165 172.917 776.107 170.573Z",
    fill: "url(#paint4_linear_101_569)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_101_569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M914.271 409.833C928.314 415.685 941.576 422.707 954.448 430.899C1040.65 484.732 1095.26 589.669 1079.27 689.925C1062.89 791.74 955.228 936.467 848.74 957.532C814.024 964.554 778.528 954.802 744.593 944.269C687.643 926.715 634.204 898.237 578.034 881.853C556.191 875.612 532.397 874.051 511.333 882.633C474.667 897.457 465.695 929.445 450.093 961.824C432.54 998.493 402.895 1029.31 367.008 1048.43C293.286 1087.44 198.11 1069.1 129.848 1026.97C28.431 964.554 -7.84507 841.673 25.7006 730.105C34.2821 701.237 47.9344 672.76 70.5582 652.475C109.175 617.366 167.295 611.125 218.003 623.998C253.109 632.97 285.095 650.134 315.52 668.859C340.484 684.463 363.498 705.919 394.313 705.919C456.724 706.309 475.837 625.948 495.73 581.087C521.865 521.792 565.942 469.909 620.552 435.19C708.707 378.626 818.315 368.873 914.271 409.833Z",
    fill: "url(#paint5_linear_101_569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.304 410.071C928.34 415.921 941.596 422.941 954.462 431.132C1040.63 484.954 1095.21 589.87 1079.22 690.105C1062.85 791.9 955.242 936.597 848.803 957.658C814.104 964.678 778.624 954.928 744.704 944.397C687.781 926.847 634.367 898.375 578.224 881.994C556.39 875.754 532.607 874.194 511.553 882.774C474.904 897.595 465.937 929.577 450.342 961.948C432.797 998.61 403.166 1029.42 367.296 1048.53C293.608 1087.53 198.476 1069.2 130.247 1027.08C28.8768 964.678 -7.38235 841.822 26.1477 730.277C34.7251 701.415 48.3711 672.944 70.9844 652.663C109.583 617.561 167.676 611.321 218.361 624.191C253.45 633.162 285.421 650.323 315.832 669.044C340.784 684.644 363.787 706.095 394.588 706.095C456.97 706.485 476.074 626.141 495.958 581.289C522.08 522.006 566.137 470.134 620.721 435.422C708.835 378.869 818.392 369.119 914.304 410.071Z",
    fill: "url(#paint6_radial_101_569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.33455 1211.1C-180.644 1078.07 -77.667 785.109 92.0119 695.386C155.593 661.837 229.705 648.964 301.087 658.326C365.448 666.909 445.802 688.754 511.723 663.788C561.652 644.673 584.666 597.471 610.8 554.56C683.352 435.19 866.293 412.954 957.179 526.083C990.724 567.824 1004.38 625.948 987.994 677.051C949.377 795.641 819.875 744.928 746.543 808.515C717.288 833.871 709.487 884.584 692.324 918.523C674.771 953.241 653.317 986.4 630.303 1018C581.935 1084.7 523.035 1145.56 455.164 1192.76C319.811 1287.17 150.522 1315.25 7.3675 1219.68C3.46684 1216.95 -0.433886 1214.22 -4.33455 1211.1Z",
    fill: "url(#paint7_linear_101_569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.33455 1211.1C-180.644 1078.07 -77.667 785.109 92.0119 695.386C155.593 661.837 229.705 648.964 301.087 658.326C365.448 666.909 445.802 688.754 511.723 663.788C561.652 644.673 584.666 597.471 610.8 554.56C683.352 435.19 866.293 412.954 957.179 526.083C990.724 567.824 1004.38 625.948 987.994 677.051C949.377 795.641 819.875 744.928 746.543 808.515C717.288 833.871 709.487 884.584 692.324 918.523C674.771 953.241 653.317 986.4 630.303 1018C581.935 1084.7 523.035 1145.56 455.164 1192.76C319.811 1287.17 150.522 1315.25 7.3675 1219.68C3.46684 1216.95 -0.433886 1214.22 -4.33455 1211.1Z",
    fill: "url(#paint8_radial_101_569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.5 565C409.103 565 395 550.897 395 533.5C395 516.103 409.103 502 426.5 502C443.897 502 458 516.103 458 533.5C458 550.897 443.897 565 426.5 565Z",
    fill: "url(#paint9_linear_101_569)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_569",
    x1: 40.3663,
    y1: 1135.4,
    x2: 1657.4,
    y2: 244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_101_569",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(698.531 259.791) rotate(79.6257) scale(1313.6 1235.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_569",
    x1: 1161.45,
    y1: -91.9261,
    x2: 133.503,
    y2: 1567.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_101_569",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(857.512 520.069) rotate(-122.724) scale(1401.84 2365.81)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_101_569",
    x1: 798.509,
    y1: 209.896,
    x2: 657.779,
    y2: 241.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5183,
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_101_569",
    x1: -46.1521,
    y1: 1083.25,
    x2: 1431.73,
    y2: 276.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_101_569",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(552.764 278.93) rotate(79.7207) scale(1206.28 1124.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_101_569",
    x1: 974.014,
    y1: -44.1489,
    x2: 25.8375,
    y2: 1472.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_101_569",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(697.435 518.015) rotate(-122.48) scale(1284.19 2158.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_101_569",
    x1: 352.913,
    y1: 585.344,
    x2: 503.113,
    y2: 479.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5183,
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 768,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_101_569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 511,
    height: 393,
    fill: "white",
    transform: "translate(769 375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_101_569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1178,
    height: 538,
    fill: "white",
    transform: "matrix(-1 0 0 1 1082 356)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDesktop);
export default __webpack_public_path__ + "static/media/home_desktop.9b2e9e67b46261781cf4109df22e3c15.svg";
export { ForwardRef as ReactComponent };